<template>
  <div id="productCenter" name="productCenter">
    <img src="assets/images/productCenter/productCenterIcon.png" alt="">
    <h2 class="blue section-title">{{ t('productCenterTitle') }}</h2>
    <div class="en-products">
      <div class="docode-container">
        <img src="assets/images/productCenter/docode.svg">
        <div class="docode-text">
          <h1>Docode<span class="label label-danger">NEW</span></h1>
          <p>
            The ultimate solution for mobile payment in the world.
          </p>
        </div>
        <div class="explore-more">
          <a href="./docode.html">Explore More</a>
        </div>
      </div>
      <div class="en-product-row" v-for="row in products">
        <a :href="item.link" v-for="item in row">
          <div class="thumbnail">
            <div class="cover">
              <img :src="item.url" :alt="item.title">
            </div>
            <h3>{{ t(item.title) }}</h3>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ProductCenter',
    data() {
      return {
        products: [
          [{
            url: 'assets/images/productCenter/smartAPP.png',
            title: 'smartAPP',
            link: './products.html#smartAPP',
          },
          {
            url: 'assets/images/productCenter/elitePOS.png',
            title: 'elitePOS',
            link: './products.html#elitePOS',
          },
          {
            url: 'assets/images/productCenter/cashierAggregator.png',
            title: 'cashierAggregator',
            link: './products.html#cashierAggregator',
          }],
          [{
            url: 'assets/images/productCenter/embraceCapability.png',
            title: 'embraceCapability',
            link: './products.html#embraceCapability',
          },
          {
            url: 'assets/images/productCenter/dashboard.png',
            title: 'visibleDashboard',
            link: './products.html#visibleDashboard',
          },
          {
            url: 'assets/images/productCenter/beyondImagination.png',
            title: 'beyondImagination',
            link: './products.html#beyondImagin',
          }],
        ],
      }
    },
    locales: {
      en: {
        productCenterTitle: 'PRODUCT CENTER',
        smartAPP: 'Smart APP',
        cashierAggregator: 'Cashier Aggregator',
        visibleDashboard: 'Dashboard',
        elitePOS: 'Elite POS',
        embraceCapability: 'Embrace Capability',
        beyondImagination: 'Beyond Imagination',
      },
      jp: {
        productCenterTitle: '製品ライン',
        smartAPP: 'スマートAPP',
        cashierAggregator: 'PCレジ',
        visibleDashboard: 'データ可視化',
        elitePOS: 'スマートCCT端末',
        embraceCapability: '拡張性',
        beyondImagination: 'ビジョン',
      }
    }
  };

</script>
<style lang="less">
  #productCenter {
    margin: 0;
    padding: 50px 0 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    > h2 {
      margin-top: 20px;
      margin-bottom: 40px;
    }
  }
  
  .docode-container {
    height: 158px;
    margin-bottom: 20px;
    box-shadow: 0 5px 8px #E4E4E4;
    border: 1px solid #E4E4E4;
    overflow: auto;
    &:hover {
      .docode-text h1 {
        color: #828282;
      }
    }
    > img {
      width: 45px;
      margin: 16px 100px 0;
      float: left;
      display: inline-block;
    }
    > .docode-text {
      display: inline-block;
      float: left;
      height: 156px;
      width: 270px;
      >h1 {
        color: #2AC1D7;
        position: relative;
        margin-top: 30px;
        margin-bottom: 14px;
        font-family: 'Helvetica Inserat LT', 'Microsoft YaHei';
        .label {
          position: absolute;
          top: 5px;
          margin-left: 4px;
          display: inline-block;
          font-size: 12px;
          padding: .3em .6em .2em;
        }
      }
      p {
        margin-top: 0;
        font-size: 14px;
        color: #323232;
      }
    }
    > .explore-more {
      display: inline-block;
      float: left;
      padding-top: 63px;
      padding-left: 154px;
      height: 93px;
      a {
        width: 114px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: #FFF;
        background-color: #2AC1D7;
        text-decoration: none;
        padding: 8px 10px;
        border-radius: 4px;
      }
    }
  }
  
  .en-product-row {
    display: flex;
    flex-direction: row;
    box-shadow: 0 5px 8px #E4E4E4;
    background: #FFF;
    > a {
      text-decoration: none;
      > .thumbnail {
        border: 1px solid #E4E4E4;
        width: 300px;
        height: 260px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
  
  .en-product-row:first-of-type {
    margin-bottom: 20px;
  }
  
  .en-product-row .thumbnail > .cover {
    height: 102px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .en-product-row .thumbnail > h3 {
    font-family: 'Helvetica Inserat LT', 'Microsoft YaHei';
    font-size: 22px;
    margin-bottom: 5px;
  }
  
  .japanese .en-product-row .thumbnail > h3 {
    font-family: inherit;
  }
  
  .en-product-row:nth-of-type(2) .thumbnail > h3 {
    color: #2AC1D7;
  }
  
  .en-product-row:last-of-type .thumbnail > h3 {
    color: #5CBD84;
  }
  
  .en-product-row .thumbnail:hover > h3 {
    color: #828282;
  }
  
  .en-product-row .thumbnail > a {
    font-size: 14px;
    margin-top: 0;
    color: #727272;
    text-decoration: none;
  }
  
  @media screen and (max-height: 800px) {
    #productCenter {
      padding-top: 30px;
    }
    #productCenter > h2 {
      margin-bottom: 30px;
    }
    .docode-container {
      height: 138px;
      margin-bottom: 10px;
      > img {
        width: 40px;
        margin: 12px 60px 0;
      }
      > .docode-text {
        height: 136px;
        width: 270px;
        >h1 {
          margin-top: 20px;
          margin-bottom: 10px;
        }
      }
      > .explore-more {
        width: 242px;
        padding-left: 80px;
        padding-top: 53px;
      }
    }
    .en-product-row > a > .thumbnail {
      width: 225px;
      height: 170px;
    }
    .en-product-row .thumbnail > .cover {
      height: 80px;
    }
  }
</style>


// WEBPACK FOOTER //
// ProductCenter.vue?610cba34